import { render, staticRenderFns } from "./SmallBusinessPlanDescription.vue?vue&type=template&id=d35b7610&scoped=true&"
import script from "./SmallBusinessPlanDescription.vue?vue&type=script&lang=js&"
export * from "./SmallBusinessPlanDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35b7610",
  null
  
)

export default component.exports